<template>
    <span class="app-send-verification-mail" v-if="!currentCustomer.emailVerified || showForced">
      <dyn-slot :slot-data="slotData"><slot name="txtBefore"></slot></dyn-slot>
      <span class="send-verification-email-btn" role="button" v-on:click="sendVerificationEmail"><slot name="lblButton">Erneut Senden</slot></span>
      <slot name="txtAfter"></slot>
    </span>
    <span class="app-send-verification-mail" v-else>
        <slot name="txtNotVerified"></slot>
    </span>
</template>

<script>
import gql from 'graphql-tag'
import { splitError } from '../../../../../helper/splitError'
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import DynSlot from '@/components/generic/DynSlot.vue'
import transaction from '@/mixins/transaction'

export default {
  name: 'SendVerificationMail',
  data () {
    return {
      currentCustomer: {
        email: null,
        emailVerified: true
      },
      show: false
    }
  },
  components: { DynSlot },
  props: {
    successMessage: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      required: true
    },
    showForced: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    slotData () {
      return {
        email: this.currentCustomer.email
      }
    }
  },
  mixins: [
    transaction('sendVerificationEmail')
  ],
  methods: {
    sendVerificationEmail: function () {
      const me = this
      const graphQlClient = me.$apolloProvider.defaultClient

      graphQlClient.mutate({
        mutation: gql`mutation sendVerificationEmail {
            sendVerificationEmail
        }`
      }).then((response) => {
        me.$store.commit('Transaction/removeTransactionId', 'sendVerificationEmail', { root: true })
        if (response.data.sendVerificationEmail === true) {
          if (me.successMessage) {
            me.$store.commit('addMessage', { type: 'success', message: 'Sie erhalten an die eingegebene E-Mail-Adresse eine E-Mail mit einem Bestätigungslink.' })
          } else {
            window.location.href = this.link
          }
          this.markShown()
        } else me.$store.commit('addError', 'Die E-Mail konnte nicht versendet werden')
      }).catch((error) => {
        splitError(error).forEach(e => me.$store.commit('addError', e))
      })
    },
    markShown () {
      this.$store.commit('markModalShown', 'emailVerified')
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query sendVerificationEmail{
        currentCustomer {
          emailVerified
          email
        }
      }`, this, 'currentCustomer')
    }
  }
}
</script>
